import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'nf-condition',
  templateUrl: './condition.component.html',
  styleUrls: ['./condition.component.css']
})
export class ConditionComponent implements OnInit {
  @Input('nfData') set setNfData(data: any) {
    if (data) {
      this.filterConditions = data;
    }
  }
  @Input() set optionsData(data: any) {
    if (data) {
      this.filterConditionsSelectAll = data;
      this.filterConditionsSelect = data;
    }
  }
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  filterConditions = [];
  filterConditionsSelectAll = [];
  filterConditionsSelect = [];

  constructor() { }

  ngOnInit() {
  }

  // 添加筛选条件
  addFilterCondition() {
    this.filterConditions.push({
      title: null,
      field: null,
      type: null,
      value: null,
      valueText: null,
      operators: [],
      operator: {
        title: null,
        operator: null
      }
    });
    this.handleConditionDataChange();
  }

  // 删除筛选条件
  deleteFilterCondition(index: number) {
    this.filterConditions.splice(index, 1);
    this.handleConditionDataChange();
  }

  // 筛选条件的主题搜索
  conditionSelectSearch(event) {
    if (event['data']) {
      this.filterConditionsSelect = this.filterConditionsSelectAll.filter((item: {title: string; field: string;}) => {
        return item.title.includes(event.data);
      });
    } else {
      this.filterConditionsSelect = this.filterConditionsSelectAll;
    }
  }

  // 处理主题选项更改事件
  handleFilterConditionSelectChange(conditionSelect, condition) {
    condition['title'] = conditionSelect['title'];
    condition['field'] = conditionSelect['field'];
    condition['valueConfig'] = conditionSelect['value'];
    condition['visible'] = false;
    if (conditionSelect['operators'] && conditionSelect['operators']) {
      condition['operators'] = conditionSelect['operators'];
      condition['operator']['title'] = conditionSelect['operators'][0]['title'];
      condition['operator']['operator'] = conditionSelect['operators'][0]['operator'];
    }
    condition['value'] = null;
    condition['valueText'] = null;
    this.filterConditionsSelect = this.filterConditionsSelectAll;
    this.handleConditionDataChange();
  }

  // 处理操作符选项变更
  handleConditionOperatorChange(condition, operator) {
    condition['operator']['title'] = operator['title'];
    condition['operator']['operator'] = operator['operator'];
    condition['operatorVisible'] = false;
    this.handleConditionDataChange();
  }

  // 处理筛选值变更
  handleConditionValueChange(condition, option) {
    condition['value'] = option['id'];
    condition['valueText'] = option['title'];
    condition['valueVisible'] = false;
    this.handleConditionDataChange();
  }

  handleConditionDataChange() {
    this.nfDataChange.emit(this.filterConditions);
  }
}
